'use client';

import { useEffect } from 'react';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/** Public Knowledge Base (Confluence). Prefer this over the JSM portal for docs. */
const KNOWLEDGE_BASE_URL =
  'https://abri-support.atlassian.net/wiki/spaces/BHC/overview';

export default function RedirectDocumentation() {
  useDocumentTitle('Documentation');

  useEffect(() => {
    window.location.replace(KNOWLEDGE_BASE_URL);
  }, []);

  return null;
}
